// extracted by mini-css-extract-plugin
export var backupIcon = "_sx-1";
export var image = "_sx-0";